export const ErrorText = {
  DATE_IN_FUTURE: 'The date is in future',
  DEFAULT: 'Something went wrong. Please try again later',
  LOCALSTORAGE_DISABLED: 'Storage is disabled',
  LOCALSTORAGE_MUST_BE_ENABLED: 'You need to enable LocalStorage to run this app.',
  REQUEST_FAILURE: 'Request failed with an error',
};
